import { Button } from 'bootstrap'
import React from 'react'
import './Projects.css'


function Projects() {
    const currentDateTime = Date()
  return (
    <div className='projects'>
       <h1>Some Things I've Built</h1>
       <div className='wrapper'>
          <div className='project__id'>
            <img style={{height:'250px',width:'100%'}} src="https://i.ibb.co/yWbbTRz/christian-wiediger-rymh7-EZPq-Rs-unsplash.jpg" />
            <h1>Amazon Clone</h1>
            <span className='spandiv'> Amazon website buld with FULL E-commerce functionlity using ReactJS, Firebase and Stripe.<br />
                  Accounts and login page<br />
                  Products Page<br />
                  Cart and Checkout Page<br />
                  Real Payments <br />
                  Order History Page <br />
                  Amazon Online Store build using Javascript framework, ReactJs and Firebase Backend. Allows <br />
                  Client sign up hence signing in and signing out. Allows navigation through products and adding <br />
                  them to bucket.Lastly allows checkout functions. Payment are made through Stripe.</span>
             <a href="https://e-clone-992b6.web.app/">  
            <button className='visit' >amazonclone.com</button>
            </a>   
            <div className='footer'>
                <span className='span__time'>{currentDateTime}</span>
            </div>
          </div>

          <div className='project__id'>
            <img style={{height:'250px',width:'100%'}} src="https://i.ibb.co/RSFGFMW/bookstore.jpg"/>
            <h1>Online Book Store</h1>
            <span className='spandiv'>
                 Online BookStore build from begenning to end with AWS, React, and Stripe, and very soon safaricom<br />
                  paybill integrated with Daraja API. The project uses Amplify, AppSync, DynamoDB, S3, Lambda services <br />
                  in AWS and React Hooks, Context API in ReactJs. All this technology have been fit together inside <br />
                  this full-stack projectt.
            </span>
             <a href="https://main.d3nr249n6gkhvf.amplifyapp.com/">     
            <button className='visit' >onlinebookstore.com</button>
            </a>
            <div className='footer'>
                <span className='span__time'>{currentDateTime}</span>
            </div>
          </div>

          <div className='project__id'>
            <img style={{height:'250px',width:'600px'}}src="https://i.ibb.co/QYMd445/whatsapp.jpg" />
            <h1>Whatsapp Clone</h1>
            <span className='spandiv'> 
            This build was built using React for frontend and Nodejs for backend.Its a MERN stack app which includes<br />
                  MongoDB real time database, Express, React and Node. It also has firebase firestore for chat rooms.
            </span>
             <a href="https://master.d2u264hj3opr7l.amplifyapp.com/">    
            <button className='visit' >whatsappclone.com</button>
            </a> 
            <div className='footer'>
                <span className='span__time'>{currentDateTime}</span>
            </div>
          </div>

       </div>
    </div>
  )
}

export default Projects